import React from 'react';
import { Box } from '@mantine/core';
import { IconTruckDelivery } from '@tabler/icons-react';
import type { ColumnDef } from '@tanstack/react-table';
import { TarjetaTablaEditable } from '../../../globales/componentes/tabla/tarjetaTablaEditable';
import { columnaAcciones, columnaTexto } from '../../../globales/componentes/tabla/columnasEditables';
import type { ITablaEditable } from '../../../globales/componentes/tabla/useEdicionFilas';
import type { IIncotermPostventa } from '../../../modelos/CotizadorPostventa/entidades/IConfiguracionPostventa';

const COLUMNAS_INCOTERMS: ColumnDef<IIncotermPostventa>[] = [
    columnaAcciones<IIncotermPostventa>(),
    columnaTexto<IIncotermPostventa>('Codigo', 'Código'),
    columnaTexto<IIncotermPostventa>('Descripcion', 'Descripción')
];

/** Pestaña "Incoterms": opciones del campo Incoterm de los repuestos. */
export const IncotermsPostventaVista: React.FC<{ incoterms: ITablaEditable<IIncotermPostventa> }> = ({ incoterms }) => (
    <Box maw={720} h="100%">
        <TarjetaTablaEditable
            titulo="Incoterms"
            icono={<IconTruckDelivery size={18} />}
            nota="Condiciones de entrega disponibles para los repuestos de la cotización."
            tabla={incoterms}
            columnas={COLUMNAS_INCOTERMS}
        />
    </Box>
);
